export const soundEffect1 = new Audio('/sounds/soundEffect1.mp3')
